import styled from 'styled-components';

const StyledClientsContainer = styled.div``;

export default StyledClientsContainer;
